
import React from 'react';
import { Technique } from '@/types/technique';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

interface TechniqueInfoCardsProps {
  technique: Technique;
}

export const TechniqueInfoCards: React.FC<TechniqueInfoCardsProps> = ({ technique }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-xl">Key Points</CardTitle>
          <CardDescription>Focus on these elements for proper execution</CardDescription>
        </CardHeader>
        <CardContent>
          {technique.key_points.length > 0 ? (
            <ul className="list-disc pl-5 space-y-2">
              {technique.key_points.map((point: string, index: number) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          ) : (
            <p className="text-muted-foreground">No key points available</p>
          )}
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle className="text-xl">Common Mistakes</CardTitle>
          <CardDescription>Issues to watch out for</CardDescription>
        </CardHeader>
        <CardContent>
          {technique.common_mistakes.length > 0 ? (
            <ul className="list-disc pl-5 space-y-2">
              {technique.common_mistakes.map((mistake: string, index: number) => (
                <li key={index}>{mistake}</li>
              ))}
            </ul>
          ) : (
            <p className="text-muted-foreground">No common mistakes listed</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
